import './Holidays.scss';

import dayjs from 'dayjs';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';

import { HolidayType } from './Holiday.functions';

function SingleMonth({
  month,
  year,
  holidays,
  setIdHoliday,
}: {
  month: number;
  year: string;
  holidays: HolidayType[];
  setIdHoliday: (id: number) => void;
}) {
  const holidayMap = new Map<string, any>();

  holidays.forEach((h) => {
    const key = dayjs(h.date).format('YYYY-MM-DD');
    holidayMap.set(key, h);
  });

  const getHoliday = (date: Date) =>
    holidayMap.get(dayjs(date).format('YYYY-MM-DD'));

  const dateTemplate = (date: any) => {
    const fullDate = new Date(date.year, date.month, date.day);
    const holiday = getHoliday(fullDate);

    const handleHolidayClick = (idHoliday: number) => {
      setIdHoliday(idHoliday);
    };

    return (
      <div
        data-pr-tooltip={holiday?.description}
        style={{
          width: '4rem',
          height: '4rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '20%',
          background: holiday?.description ? '#ef4444' : 'transparent',
          color: holiday?.description ? 'white' : 'inherit',
          fontSize: '1rem',
          fontWeight: holiday?.description ? 600 : 400,
          cursor: holiday?.description ? 'pointer' : 'default',
        }}
        onClick={() => holiday && handleHolidayClick(holiday?.id)}
      >
        {date.day}
      </div>
    );
  };

  return (
    <div className="month-card">
      <div className="month-title">
        {dayjs(new Date(Number(year), month, 1)).format('MMMM')}
      </div>
      <Calendar
        value={new Date(Number(year), month, 1)}
        inline
        dateTemplate={dateTemplate}
        headerTemplate={() => <div style={{ height: 0 }} />}
      />
      <Tooltip
        target=".month-card [data-pr-tooltip]"
        position="top"
        className="custom-tooltip"
      />
    </div>
  );
}

export default SingleMonth;
